var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40H20L19.9967 32.0044L40 0H0V40Z",
    fill: "#5CCEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 39.9999H17.563L9.15008 26.4338L23.3882 13.3333L40 39.9999Z",
    fill: "#4D94FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05277 10H20.413C22.4252 10 24.3551 10.7994 25.7779 12.2222C27.2008 13.6451 28.0001 15.5749 28.0001 17.5871V28.9474C28.0001 29.5287 27.5289 30 26.9475 30H15.5873C13.575 30 11.6452 29.2006 10.2224 27.7778C8.79949 26.3549 8.00014 24.4251 8.00014 22.4129V11.0526C8.00014 10.4713 8.47142 10 9.05277 10Z",
    fill: "#F7F7F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 14.0001H23.0001V16.9144H19.6381V26.0001H16.3622V16.9144H13.0001V14.0001Z",
    fill: "#4D94FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToLogo);
export default __webpack_public_path__ + "static/media/TO-logo.83bdb778303e433742bb76b196594ffd.svg";
export { ForwardRef as ReactComponent };